// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__38_IT","info":"UpdateTermsInfo_info__23x1d"};